import { useTranslation } from 'react-i18next';
import { mainSiteUrl } from '@/mocks/categories';

export default function FinalCta() {
  const { t } = useTranslation();

  return (
    <section className="bg-primary-500">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-16 md:py-20 text-center">
        <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50">{t('final.title')}</h2>
        <p className="mx-auto mt-4 max-w-2xl text-sm md:text-base leading-relaxed text-background-50/90">
          {t('final.subtitle')}
        </p>
        <a
          href={mainSiteUrl}
          target="_blank"
          rel="noopener nofollow"
          className="mt-8 inline-flex items-center gap-2 rounded-md bg-background-50 px-7 py-3.5 text-sm md:text-base font-semibold text-primary-700 hover:bg-background-100 transition-colors cursor-pointer whitespace-nowrap"
        >
          {t('final.cta')}
          <i className="ri-arrow-right-up-line" />
        </a>
      </div>
    </section>
  );
}